import React from 'react'
import { Chip, Stack, useTheme, useMediaQuery } from '@mui/material'
import { Lease, LeaseStatus, LeaseStatusType } from '../../types/lease'

interface LeaseStatusBadgesProps {
    leases: Lease[]
    selectedLease: Lease | null
    onLeaseSelect: (lease: Lease) => void
}

const getStatusLabel = (status: LeaseStatusType): string => {
    switch (status) {
        case LeaseStatus.APPLICANT:
            return 'Applicant'
        case LeaseStatus.CANCELLED:
            return 'Cancelled'
        case LeaseStatus.FUTURE:
            return 'Future'
        case LeaseStatus.CURRENT:
            return 'Active'
        case LeaseStatus.NOTICE:
            return 'Notice'
        case LeaseStatus.PAST:
            return 'Past'
        default:
            return 'Unknown'
    }
}


export const LeaseStatusBadges: React.FC<LeaseStatusBadgesProps> = ({
    leases,
    selectedLease,
    onLeaseSelect,
}) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Stack
            direction="row"
            spacing={1}
            sx={{
                flexWrap: 'wrap',
                gap: 1,
            }}
        >
            {leases.map((lease) => {
                const unitName = lease.area?.unit_name || 'N/A'
                const areaLabel = lease.area?.area_label || 'N/A'
                const statusLabel = getStatusLabel(lease.status)
                const label = `${unitName}${areaLabel ? ` - ${areaLabel}` : ''} (${statusLabel})`

                return (
                    <Chip
                        key={lease.id}
                        label={label}
                        onClick={() => onLeaseSelect(lease)}
                        size={isMobile ? 'small' : 'medium'}
                        style={{
                            backgroundColor: '#2a2f35',
                            color: '#fff',
                            borderRadius: 16,
                            cursor: 'pointer',
                            border: selectedLease?.id === lease.id ? '2px solid #fff' : 'none',
                            fontSize: isMobile ? '0.75rem' : '0.875rem',
                            height: isMobile ? 28 : 32,
                        }}
                    />
                )
            })}
        </Stack>
    )
}